import DataMap from 'assets/components/dataMap/DataMap';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useSalesContractProvider } from '../../Sales.Contract.Hooks';

const ContractInfoStatusAuditLogs = () => {
  const { lang, translate } = getLocales();
  const { contractStatusAuditLogListApi } = useSalesContractProvider();

  return (
    <>
      {!contractStatusAuditLogListApi.payload?.data?.length ? (
        <ErrorWrapper children={lang.noInfo} />
      ) : (
        <table className={ThemeTableSimple}>
          <thead>
            <tr>
              <th>{lang.oldStatus}</th>
              <th>{lang.newStatus}</th>
              <th>{lang.changedOn}</th>
              <th>{lang.changedBy}</th>
            </tr>
          </thead>
          <tbody>
            <DataMap
              data={contractStatusAuditLogListApi?.payload?.data}
              render={({ data: log }) => (
                <tr key={log.id}>
                  <td>{translate(log.oldStatus)}</td>
                  <td>{translate(log.newStatus)}</td>
                  <td>{log.createdAtUtc}</td>
                  <td>{log.createdBy?.displayInfo?.title}</td>
                </tr>
              )}
            />
          </tbody>
        </table>
      )}
    </>
  );
};

export default ContractInfoStatusAuditLogs;
